import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock, MapPin, Headphones } from 'lucide-react';

const FEATURES = [
  { icon: ShieldCheck, title: 'Verified', subtitle: 'Drivers' },
  { icon: Clock, title: 'On-time', subtitle: 'Service' },
  { icon: MapPin, title: 'Available in', subtitle: 'Major Cities' },
  { icon: Headphones, title: '24/7', subtitle: 'Support' },
];

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12, delayChildren: 0.7 } },
};

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] } },
};

export default function HeroFeatures() {
  return (
    <motion.div
      className="hero-features"
      aria-label="Key benefits"
      initial="hidden"
      animate="visible"
      variants={stagger}
    >
      {FEATURES.map(({ icon: Icon, title, subtitle }) => (
        <motion.div
          className="hero-feature"
          key={`${title}-${subtitle}`}
          variants={fadeUp}
          whileHover={{ y: -4, scale: 1.04 }}
        >
          <span className="hero-feature-icon" aria-hidden="true">
            <Icon size={20} strokeWidth={2} />
          </span>
          <span className="hero-feature-text">
            <span className="hero-feature-title">{title}</span>
            <span className="hero-feature-sub">{subtitle}</span>
          </span>
        </motion.div>
      ))}
    </motion.div>
  );
}
